import React, { useRef } from "react";
import { Outlines, useGLTF } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";

export default function Model(props) {
  const { nodes, materials } = useGLTF("/plots/03-Factory.glb");
  const outlineThickness = .008

  let built = props.built
  const model = useRef()

  useFrame((state, delta) => {
    if(!built && model.current.scale.y < 1)
    {
      AnimateIn()
    }
    else
    {
      IdleAnimation()
    }
  })

  function AnimateIn() {
    model.current.scale.y += (1 - model.current.scale.y) / 10
    model.current.scale.x += (1 - model.current.scale.x) / 10
    model.current.scale.z += (1 - model.current.scale.z) / 10
    if(model.current.scale.y > .997)
    {
      model.current.scale.x = 1
      model.current.scale.y = 1
      model.current.scale.z = 1
      // console.log(model.current.scale)
    }
  }

  function IdleAnimation()
  {
    // console.log('idleAnimating')
  }
  
  return (
    <group {...props} dispose={null} ref={model} scale={[.7,.2,.7]}>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube564.geometry}
        material={materials["00-Base3.001"]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube567.geometry}
        material={materials["09-FactoryLevel2"]}
        position={[-0.263, 0.652, -0.049]}
        scale={[1, 2.413, 1]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube570.geometry}
        material={materials["06-WindowSill1"]}
        position={[0.078, 0.658, 0.357]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube589.geometry}
        material={materials["09-FactoryGray"]}
        position={[0.764, 0.141, -0.011]}
        rotation={[-0.26, 0, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube591.geometry}
        material={materials["04-RocksGray"]}
        position={[0.764, 0.228, 0.121]}
        rotation={[0.013, 0, 0]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube592.geometry}
        material={materials["10-FactoryVoid"]}
        position={[0.173, 0.327, -0.529]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube727.geometry}
        material={materials["10-PipesBlue"]}
        position={[0.251, 0.294, 0.046]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube730.geometry}
        material={materials["00-Base2"]}
        position={[-0.263, 0.681, -0.049]}
        scale={[1, 2.413, 1]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cube733.geometry}
        material={materials["07-WindowMat"]}
        position={[0.078, 0.658, 0.357]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder096.geometry}
        material={materials["10-PipesBlue"]}
        position={[-0.059, 0.281, 0.754]}
      ><Outlines thickness={outlineThickness}/></mesh>
      <mesh
        castShadow
        receiveShadow
        geometry={nodes.Cylinder098.geometry}
        material={materials["09-ConveyorOrange"]}
        position={[-0.074, 0.254, 0.759]}
      ><Outlines thickness={outlineThickness}/></mesh>
    </group>
  );
}

useGLTF.preload("/plots/03-Factory.glb");